<!-- @format -->

<app-top-menu></app-top-menu>

<div class="container mt-5">
	<div class="bg-white">
		<div class="reports-heading mb-3 mt-2 flex-wrap gap-2">
			<div class="ms-1 top-bar-div">
				<div class="mt-3">
					<h6>PAYMENTS</h6>
				</div>
			</div>

			<div class="right-buttons mt-3">
				<div class="d-flex justify-content-end">
					<button
						class="custom-search-button"
						(click)="toggleSearch()"
					>
						Search
						<span class="mdi mdi-magnify custom-search-icon"></span>
					</button>
				</div>
			</div>
		</div>

		<div
			class="search-parameters"
			*ngIf="showSearch"
		>
			<form
				class="search-form"
				[formGroup]="searchForm"
			>
				<button
					class="btn btn-outline-secondary btn-sm position-absolute top-0 end-0"
					(click)="toggleSearch()"
				>
					<span class="mdi mdi-close"></span>
				</button>
				<div class="row mt-2 mb-3">
					<div class="col-md-3 mt-2">
						<label>Payment Reference</label>
						<input
							type="text"
							class="form-control small-option-font"
							formControlName="rrr"
						/>
					</div>
					<div class="col-md-3 mt-2">
						<label>ASIN</label>
						<input
							type="text"
							class="form-control small-option-font"
							formControlName="asinExternal"
						/>
					</div>

					<div class="col-md-3 mt-2 col-sm-9">
						<button
							[disabled]="
								!searchForm.get('rrr').value &&
								!searchForm.get('asinExternal').value
							"
							class="btn btn-sm search-button small-option-font"
							(click)="search(); toggleSearch()"
							type="submit"
						>
							Search
						</button>
					</div>
					<div class="col-md-3 mt-2 col-sm-9">
						<button
							class="btn btn-sm reset-button small-option-font"
							(click)="resetForm()"
							type="submit"
						>
							Reset
						</button>
					</div>
				</div>
			</form>
		</div>

		<!-- <div class="table-responsive"> -->
		<table class="table table-striped table-hover table-bordered">
			<thead class="table-dark">
				<tr>
					<th
						scope="col"
						class="assess-table-head"
					>
						S/N
					</th>
					<th
						scope="col"
						class="assess-table-head"
					>
						ASIN
					</th>
					<th
						scope="col"
						class="assess-table-head"
					>
						NAME
					</th>
					<th
						scope="col"
						class="assess-table-head"
					>
						REVENUE NAME
					</th>
					<th
						scope="col"
						class="assess-table-head"
					>
						REVENUE CODE
					</th>
					<th
						scope="col"
						class="assess-table-head"
					>
						PAYMENT DATE
					</th>
					<th
						scope="col"
						class="assess-table-head"
					>
						PAYMENT REF.
					</th>
					<th
						scope="col"
						class="assess-table-head"
					>
						AMOUNT
					</th>
					<th
						scope="col"
						class="assess-table-head"
					>
						STATUS
					</th>
					<th
						scope="col"
						class="assess-table-head"
					>
						ACTION
					</th>
				</tr>
			</thead>

			<tbody *ngIf="!isSearching && details?.length > 0">
				<tr *ngFor="let eachDetail of details; let i = index">
					<td>
						<span class="badge bg-dark">{{ i + 1 + num }}</span>
					</td>
					<td>{{ eachDetail?.asin }}</td>
					<td>{{ eachDetail?.taxPayerName }}</td>
					<td>
						{{
							eachDetail?.revenueName
								| uppercase
								| removeUnderscores
						}}
					</td>
					<td>{{ eachDetail?.revenueCode }}</td>
					<td>{{ eachDetail?.paymentDate | date }}</td>
					<td>{{ eachDetail?.rrr | uppercase }}</td>
					<td>
						{{
							eachDetail?.taxDue || eachDetail?.amount
								| nairaCurrency
						}}
					</td>
					<td>
						<span
							class="badge {{
								eachDetail?.paymentStatus === 'APPROVED'
									? 'bg-success'
									: 'bg-warning'
							}}"
						>
							{{
								eachDetail?.paymentStatus
									| uppercase
									| removeUnderscores
							}}
						</span>
					</td>

					<td class="user-type-td">
						<div
							ngbDropdown
							class="d-inline"
						>
							<button
								class="btn btn-secondary btn-sm btn-flat"
								id="dropdownBasic1"
								ngbDropdownToggle
								type="button"
							>
								Action
							</button>
							<div
								ngbDropdownMenu
								aria-labelledby="dropdownBasic1"
								class="dropdown-menu-flat"
							>
								<a
									*ngIf="
										eachDetail?.paymentStatus == 'APPROVED'
									"
									style="
										font-family: Inter;
										font-size: 14px;
										font-style: normal;
									"
									ngbDropdownItem
									class="dropdown-item-flat"
									(click)="
										downloadPaymentReceipt(eachDetail?.rrr)
									"
								>
									Download Receipt
								</a>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<div class="d-flex justify-content-center mt-3">
			<p
				*ngIf="isSearching"
				class="text-muted"
			>
				Please wait...
			</p>
			<p
				*ngIf="isEmpty"
				class="text-danger"
			>
				No Payment found
			</p>
		</div>

		<div class="pagination justify-content-end">
			<ngb-pagination
				*ngIf="!isSearching && details?.length > 0"
				class="d-flex justify-content-center my-3"
				[(page)]="currentPage"
				(pageChange)="callDb($event)"
				[maxSize]="5"
				[pageSize]="pageSize"
				[collectionSize]="count"
				[boundaryLinks]="true"
				[directionLinks]="true"
				[rotate]="true"
			>
			</ngb-pagination>
		</div>

		<div
			class="d-flex justify-content-center mt-2 mb-5"
			*ngIf="searchInstruction"
		>
			<p class="text-muted">Please perform a search to view data.</p>
		</div>
	</div>
</div>

<app-footer></app-footer>
